<template>
<div class="Loading" v-if="isShow">
  <div class="box">
    <div class="head">
      <i class="el-icon-warning"></i>
      <span>提示</span>
    </div>
    <!--    数据导入中-->
    <div class="center" v-if="type === '1'">
      <img src="~@/assets/images/loading.png" alt="" class="loaingImg">
      <span>数据导入中...</span>
    </div>
    <!--    导入成功-->
    <div v-if="type === '2'">
      <div class="center">
        <img src="~@/assets/images/success.png" alt="" style="margin-bottom: 5px">
        <span>导入成功</span>
      </div>
      <div class="bottom">
        <el-button style="width: 80px" @click="close">关闭</el-button>
        <el-button type="primary" @click="$router.push('/controlPlatform/dataManagement')">进入数据管理</el-button>
      </div>
    </div>
    <!--    更新数据-->
    <div v-if="type === '3'">
      <div class="center" style="margin-bottom: 10px">
        <p>数据成果共计 <span>{{total}}</span> 条</p>
<!--        <p>已导入 <span>{{importCount}}</span> 条</p>-->
        <p>本次将更新数据 <span style="color: #59cb24">{{updateCount  }}</span> 条</p>
      </div>
      <div class="bottom">
        <el-button style="width: 80px" @click="close">取消</el-button>
        <el-button type="primary" @click="update" :disabled="updateCount === 0">确认更新</el-button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { demandAchievementImport, getDataList, getAchievementImportCount } from '@/api/demandManagement'
export default {
  name: 'Loading',
  props: {},
  components: {},
  data () {
    return {
      isShow: false,
      type: '1',
      total: 0,
      demandId: '',
      formInline: {
        pageNumber: 1,
        pageSize: 15,
        keyword: '',
        eventTypes: '',
        demandId: ''
      },
      importCount: 0,
      updateCount: 0
    }
  },
  computed: {
    name () {
      return this.data
    }
  },
  watch: {
    data (newValue, oldValue) {

    }
  },
  methods: {
    open (type, data) {
      this.type = type
      this.isShow = true
      this.demandId = data
      if (type === '1') {
        this.importData()
      }
      if (type === '3') {
        this.getDetails()
      }
    },
    close () {
      this.isShow = false
    },
    update () {
      this.open('1', this.demandId)
    },
    importData () {
      demandAchievementImport({ demandId: this.demandId }).then(res => {
        if (res.code === 200) {
          this.$emit('refresh')
          this.type = '2'
        }
      })
    },
    getDetails () {
      this.formInline.demandId = this.demandId
      getDataList(this.formInline).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.importCount = 0
          // this.updateCount = 0
          res.data.records.forEach(item => {
            if (item.status === 'IMPORTED') {
              this.importCount++
            }
          })
          // this.updateCount = res.data.total - this.importCount
        }
      })
      getAchievementImportCount(this.formInline).then(res => {
        if (res.code === 200) {
          this.updateCount = res.data
        }
      })
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.Loading{
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  z-index: 1000;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .box{
    width: 459px;
    height: auto;
    background: #3d3e40;
    border: 1px solid #565759;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.8);
    border-radius: 12px;
    box-sizing: border-box;
    padding: 24px;
    padding-top: 15px;
    .head{
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      text-align: left;
      display: flex;
      align-items: center;
      >i{
        color: rgba(0, 164, 240, 1);
        font-size: 24px;
        margin-right: 16px;
      }
    }
    .center{
      height: 110px;
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 20px;
      >p{
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #CCCCCC;
        text-align: left;
        width: 100%;
        padding-left: 40px;
        >span{
          color: white;
        }
      }
      >img{
        margin-bottom: 20px;
        &.loaingImg{
          animation:rotate 1s linear infinite;
          margin-bottom: 25px;
        }
      }
    }
    .bottom{
      text-align: right;
      >button{
        margin-left: 20px;
      }
    }
    @keyframes rotate{
      0%{-webkit-transform:rotate(0deg);}
      25%{-webkit-transform:rotate(90deg);}
      50%{-webkit-transform:rotate(180deg);}
      75%{-webkit-transform:rotate(270deg);}
      100%{-webkit-transform:rotate(360deg);}
    }
  }
}
</style>
